import webapi from '../../api/webapi'
/**
   通常設定
*/

const state = {
  goods_status: [],
  goods_info: {},
  wp_page_settings: [],
  wp_page: {},
  menu_list_page_visible:false,
  all_wp_pages:[],
}

const getters = {
  GoodsStatus: state => state.goods_status,
  GoodsInfo: state => state.goods_info,
  WPPageSettings: state => state.wp_page_settings,
  WPPage: state => state.wp_page,
  MenuListPageVisible: state=>state.menu_list_page_visible,
  WPMenuList: state => state.all_wp_pages,
  /**
    商品の欠品表示など、表示ステータスを判別する
  */
  checkLinkStatus: state=>(item)=>{
    var status_class=''
    //console.log('checkLinkStatus:' + JSON.stringify(item))
    if(item.type=="item-link"){
      //禁止枠の設定
      if(item.goods_status!=undefined && item.goods_status2!=undefined){
        if(item.goods_status=='' && item.goods_status2==''){
          //status_class='disabled initial'
          status_class=''
        }else{
          if(item.goods_status2==1 || item.goods_status2==11 || item.goods_status2==21){
            status_class='disabled'
          }
          /*
          if(item.goods_status2==2 || item.goods_status2==12 || item.goods_status2==22){
            status_class='icon'
          }
          */
          if(item.goods_status!=1){
            
            status_class='disabled'
          }
        }
      }else{
        status_class='' //仮
      }
      //禁止マークの有無
      
      if(item.enable_item_icon=='false'){
        status_class=status_class+' no_icon'
      }
      
    }
    
    return status_class
  },
  /**
    注意のテキストなどを取得する
  */
  getStatusText: (state,getters)=>(item)=>{
    var status_text=''
    if(item.type=="item-link"){
      //禁止枠の設定
      if(item.goods_status!=undefined && item.goods_status2!=undefined){
        if(item.goods_status2==1 || item.goods_status2==2){
          //有効時間外
          status_text=getters.localizeLabel("ItemStatus", "status2_1")
        }
        if(item.goods_status2==11 || item.goods_status2==12){
          //有効時間外
          status_text=getters.localizeLabel("ItemStatus", "status2_11")
        }
        if(item.goods_status2==21 || item.goods_status2==22){
          //有効時間外
          status_text=getters.localizeLabel("ItemStatus", "status2_21")
        }
        if(item.goods_status==9){
          //有効時間外
          status_text=getters.localizeLabel("ItemStatus", "status_9")
        }
        if(item.goods_status==7){
          //停止
          status_text=getters.localizeLabel("ItemStatus", "status_7")
        }
        if(item.goods_status==5){
          //アルコール提供禁止
          status_text=getters.localizeLabel("ItemStatus", "status_5")
        }
        if(item.goods_status==2){
          //欠品
          status_text=getters.localizeLabel("ItemStatus", "status_2")
        }
        
      }
      //表示メッセージの有無
      if(item.enable_item_notice=='false'){
        status_text=''
      }
    }
    
    return status_text
  },
}

// actions
const actions = {
  /**
    商品情報を取得
  */
 GetGoodsInfo({ commit,getters,dispatch}, item_code) {
  return new Promise((resolve, reject) => {
    webapi
      .request(
        'item',
        {
          shop_ip:    getters.ShopIP,
          shop_port:  getters.PortNo,
          slip_date:  getters.SlipDate,
          shop_code:  getters.ShopCode,
          slip_no:    getters.SlipNo,
          item_code:  item_code,
          lang:       getters.currentLang,
        }
      )
      .then(result => {
        commit('updateGoodsInfo',result)
        resolve(result)
      })
      .catch(errors => {
        dispatch('showErrorMessage',getters.ConvertAppError(errors))
        reject()
      })
    
  })
},
  /**
    欠品商品リストを取得
  */
  GetGoodsStatus({ commit,getters,dispatch}, order_items) {
    return new Promise((resolve, reject) => {
      webapi
        .request(
          'goods_status',
          {
            shop_ip:    getters.ShopIP,
            shop_port:  getters.PortNo,
            slip_date:  getters.SlipDate,
            shop_code:  getters.ShopCode,
            slip_no:    getters.SlipNo,
            order_item: order_items,
            image:      '0',
          }
        )
        .then(result => {
          var goods_status=[]
          if(result.hasOwnProperty('GoodsList')){
            commit('updateGoodStatus',result.GoodsList.Detail)//
            if(Array.isArray(result.GoodsList.Detail)){
              goods_status=result.GoodsList.Detail
            }else{
              goods_status=[result.GoodsList.Detail]
            }
          }
          
          resolve(goods_status)
        })
        .catch(errors => {
          
          //dispatch('showErrorMessage',getters.ConvertAppError(errors))
          reject(errors)
        })
      
    })
  },
   /**
    画像つき欠品商品リストを取得
  */
 GetGoodsStatusWidthImage({ commit,getters,dispatch}, order_items) {
  return new Promise((resolve, reject) => {
    webapi
      .request(
        'goods_status',
        {
          shop_ip:    getters.ShopIP,
          shop_port:  getters.PortNo,
          slip_date:  getters.SlipDate,
          shop_code:  getters.ShopCode,
          slip_no:    getters.SlipNo,
          order_item: order_items,
          image:      '1',
        }
      )
      .then(result => {
        var goods_status=[]
        
        if(result.hasOwnProperty('GoodsList')){
          commit('updateGoodStatus',result.GoodsList.Detail)//
          if(Array.isArray(result.GoodsList.Detail)){
            goods_status=result.GoodsList.Detail
          }else{
            goods_status=[result.GoodsList.Detail]
          }
        }
        resolve(goods_status)
      })
      .catch(errors => {
        dispatch('showErrorMessage',getters.ConvertAppError(errors))
        reject()
      })
    
  })
},
  /**
    WPページ設定を取得
  */
 GetWPPage({ commit,getters,dispatch} ,page_id) {
      
  return new Promise((resolve, reject) => {
    webapi
      .request(
        'page',
        {
          shop_ip:    getters.ShopIP,
          shop_port:  getters.PortNo,
          slip_date:  getters.SlipDate,
          shop_code:  getters.ShopCode,
          slip_no:    getters.SlipNo,
          page_id:    page_id,
          lang:       getters.currentLang,
        }
      )
      .then(result => {
        var index=0
        result[0].items.forEach(function(item){
          item['no']=index
          index++
        })
        console.log(JSON.stringify(result))
        
        commit('updateWPPage',result)//
        resolve(result)
      })
      .catch(errors => {
        dispatch('updateWPPage', getters.ConvertAppError(errors))
        reject()
      })
    
  })

},
 /**
    WPページ（トップページ）を取得
  */
 GetTopPage({ commit,getters,dispatch} ) {
      
  return new Promise((resolve, reject) => {
    webapi
      .request(
        'type_pages',
        {
          shop_ip:    getters.ShopIP,
          shop_port:  getters.PortNo,
          slip_date:  getters.SlipDate,
          shop_code:  getters.ShopCode,
          slip_no:    getters.SlipNo,
          type:       '9',
          lang:       getters.currentLang,
        }
      )
      .then(result => {
        
          if(result[0].page_type=='2' && !getters.isSubMenuCodeExist(result[0].page_id)){
          }else{
            var index=0
            result[0].items.forEach(function(item){
              item['no']=index
              index++
            })
          }
        
        commit('updateWPPage',result)//
        resolve(result)
      })
      .catch(errors => {
        dispatch('updateWPPage', getters.ConvertAppError(errors))
        reject()
      })
    
  })

},
  /**
    WPページ商品の設定を取得
  */
  GetWPPageSettings({ commit,getters,dispatch}, params) {
      
    return new Promise((resolve, reject) => {
      webapi
        .request(
          'pages',
          {
            shop_ip:    getters.ShopIP,
            shop_port:  getters.PortNo,
            slip_date:  getters.SlipDate,
            shop_code:  getters.ShopCode,
            slip_no:    getters.SlipNo,
            lang:       getters.currentLang,
            category:   params.category_id,
            page_id:    params.page_group_id
          }
        )
        .then(result => {
          var pages=[]
          
          result.forEach(function(page,page_index){
            //時間制限品の場合かつ、関連ページIDが無いものは、オーダーに存在するものだけ追加
            if(page.page_type=='2' && !getters.isSubMenuCodeExist(page.page_id) && params.page_group_id==''){
            }else{
              var index=0
              page.items.forEach(function(item){
                item['no']=index
                index++
              })
              pages.push(page)
            }
          })
          console.log(JSON.stringify(pages))
          commit('updateWPPageSettings',pages)//
          resolve(pages)
        })
        .catch(errors => {
          dispatch('showErrorMessage', getters.ConvertAppError(errors))
          reject()
        })
      
    })
  
  },
  getWPAllPageList({dispatch,getters,commit}) {

    return new Promise((resolve, reject) => {
      webapi
        .request(
          'all_pages',
          {
            shop_ip:    getters.ShopIP,
            shop_port:  getters.PortNo,
            slip_date:  getters.SlipDate,
            shop_code:  getters.ShopCode,
            slip_no:    getters.SlipNo,
            lang:       getters.currentLang,
          }
        )
        .then(result => {
          //dispatch('showLogMessage','call 伝票照会API')//実行ログ
          var cate_id=''
          var index=0
          var pages=[]
          result.forEach(function(item,index){
            //時間制限品の場合は、オーダーに存在するものだけ追加
            if(item.page_type=='2' && !getters.isSubMenuCodeExist(item.page_id)){
            }else{
              item['no']=index
              item['type']='page-link'
              item['code']=item.page_id
              index++
                if(item.page_category!=cate_id){
                  cate_id=item.page_category
                }else{
                  item.page_category_name=''
                  item.page_category_name_en=''
                  item.page_category_name_ch=''
                }
                pages.push(item)
            }
            
          })
          
          commit('updateWPAllPageList',pages)//
          resolve(pages)
        })
        .catch(errors => {
          dispatch('showErrorMessage',getters.ConvertAppError(errors))
          reject(getters.ConvertAppError(errors))
        })
      
    })
  },
  /**
    WPページ商品の設定を更新
  */
  SetWPPageSetting({ commit}, page_settings) {
    commit('updateWPPageSettings',page_settings)//
  },
  SetMenuListPageVisible({ commit,dispatch}, visibility) {
    if(visibility){
      dispatch('ClearPageTimer')
    }else{
      dispatch('SetPageTimer')
    }
    commit('updateMenuListPageVisible',visibility)//
  },
}

// mutations
const mutations = {
  updateGoodStatus(state, list) {
    if(Array.isArray(list)){
      state.goods_status=list
    }else{
      state.goods_status=[list]
    }
  },
  updateWPPageSettings(state, list) {
    if(Array.isArray(list)){
      state.wp_page_settings=list
    }else{
      state.wp_page_settings=[list]
    }
  },
  updateWPPage(state, page) {
    //if(Array.isArray(page)){
    //  state.wp_page=page
    //}else{
      state.wp_page=page[0]
    //}
    //debugger
  },
  updateGoodsInfo(state, value) {
    state.goods_info = value
  },
  updateMenuListPageVisible(state, value) {
    state.menu_list_page_visible = value
  },
  updateWPAllPageList(state, list) {
    if(Array.isArray(list)){
      state.all_wp_pages=list
    }else{
      state.all_wp_pages=[list]
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/item.js